module.exports = __webpack_public_path__ + "static/media/Steiner St, San Francisco, CA1.b6a08a1e.jpg";